import { render, staticRenderFns } from "./ProductListTable.vue?vue&type=template&id=2a85824c"
import script from "./ProductListTable.vue?vue&type=script&lang=js"
export * from "./ProductListTable.vue?vue&type=script&lang=js"
import style0 from "./ProductListTable.vue?vue&type=style&index=0&id=2a85824c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports